var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0501 18.2851C31.1958 18.2851 30.3931 18.6148 29.7904 19.2131C29.1881 19.8103 28.8575 20.6044 28.8585 21.4476L28.8569 24.5781C28.8569 24.8899 28.6002 25.1438 28.2844 25.1438C27.9697 25.1438 27.7135 24.8894 27.7135 24.5776L27.7167 16.9374C27.713 15.1957 26.2825 13.7784 24.5251 13.7784L24.4491 13.78C22.7597 13.8185 21.368 15.192 21.3308 16.8862L21.3329 22.1471C21.3329 22.4599 21.0762 22.7143 20.7615 22.7143C20.4468 22.7143 20.19 22.4604 20.19 22.1487L20.1868 15.4411C20.1874 14.5932 19.8562 13.7975 19.2539 13.2013C18.6527 12.6046 17.8532 12.2765 16.999 12.2765C15.2383 12.2786 13.8074 13.6974 13.8074 15.4391V22.1487C13.8074 22.4605 13.5506 22.7149 13.2343 22.7149C12.9196 22.7149 12.6629 22.4605 12.6629 22.1487L12.6645 3.32049C12.6645 1.57613 11.2319 0.158447 9.47068 0.158447C7.71164 0.158447 6.2807 1.57721 6.2807 3.32049L6.28017 29.3538C6.28017 29.6656 6.02342 29.9199 5.70872 29.9199C5.39403 29.9199 5.13727 29.6656 5.13727 29.3538V18.2117L4.87149 18.0448C3.59197 17.2416 1.9334 16.9846 0.995776 17.437C0.488109 17.6793 0.241455 18.0764 0.241455 18.6489L0.243581 32.8203C0.243049 37.4507 2.06263 41.804 5.36856 45.0788C8.67393 48.3536 13.0669 50.1579 17.7395 50.1584C27.3882 50.1569 35.2401 42.3781 35.2415 32.8187L35.2409 21.4459C35.2409 19.7037 33.8086 18.2851 32.0501 18.2851Z",
    fill: "url(#paint0_linear_1333_5848)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1333_5848",
    x1: 9.14458,
    y1: 8.03838,
    x2: 58.1545,
    y2: 27.8394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/hand-icon.8d2ef3b88ee78c7a6b7346a87458323a.svg";
export { ForwardRef as ReactComponent };